var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row mb-5"},[_c('div',{staticClass:"col-12 text-bold text-primary font-size-125"},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]),_c('div',{staticClass:"col-12 mt-3"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }